import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { config } from '../config';
import './GetTheApp.css';

/**
 * Where to get the phone app: store buttons, and a code to scan from a laptop.
 * Until the store links are set (VITE_APP_STORE_URL / VITE_PLAY_STORE_URL),
 * it says what to search for instead.
 */
export function GetTheApp({ email }: { email: string }) {
  const url = config.appStoreUrl || config.playStoreUrl;
  const [qr, setQr] = useState<string | null>(null);
  useEffect(() => {
    if (!url) return;
    QRCode.toString(url, { type: 'svg', margin: 0, color: { dark: '#1C1917', light: '#FFFFFF00' } })
      .then(setQr)
      .catch(() => setQr(null));
  }, [url]);

  return (
    <div className="get-app">
      <div className="get-app-body">
        {url ? (
          <>
            <div className="get-app-buttons">
              {config.appStoreUrl ? (
                <a className="btn btn-primary btn-md" href={config.appStoreUrl} target="_blank" rel="noreferrer">
                  App Store (iPhone)
                </a>
              ) : null}
              {config.playStoreUrl ? (
                <a className="btn btn-secondary btn-md" href={config.playStoreUrl} target="_blank" rel="noreferrer">
                  Google Play (Android)
                </a>
              ) : null}
            </div>
            <p className="muted">On a laptop? Scan the code with your phone&rsquo;s camera.</p>
            {config.playStoreUrl ? null : <p className="muted">On Android? EducAitor is coming to Google Play soon.</p>}
          </>
        ) : (
          <p className="muted">
            Search for <strong>EducAitor</strong> in the App Store on your iPhone.
          </p>
        )}
        <p className="get-app-signin">
          Sign in with <strong>{email}</strong>, the same as here.
        </p>
      </div>
      {qr ? <div className="get-app-qr" aria-label="Code to scan for the app" role="img" dangerouslySetInnerHTML={{ __html: qr }} /> : null}
    </div>
  );
}
